var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClearFormat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10.338 10.01 7 2H5L0 14h2.167l1.25-3h5.166l.225.54zM6 4.8 4.042 9.5h3.916zm8.616 2.7a1.25 1.25 0 0 1 1.768 0l3.116 3.116a1.25 1.25 0 0 1 0 1.768L13.384 18.5a1.25 1.25 0 0 1-1.768 0L8.5 15.384a1.25 1.25 0 0 1 0-1.768zM11 12.884 9.384 14.5l3.116 3.116L14.116 16zm.884-.884L15 15.116l3.616-3.616L15.5 8.384z",
  clipRule: "evenodd"
})));
export default SvgClearFormat;